import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import InlineSVG from 'svg-inline-react';
import { styled } from '@mui/material';
import { pxToRem } from '@themes';
import { jsx as _jsx } from "react/jsx-runtime";
var StyledIcon = styled(function (props) {
  return /*#__PURE__*/_jsx(InlineSVG, _objectSpread({
    raw: true
  }, props));
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n\n  .fill {\n    fill: currentColor;\n  }\n\n  .stroke {\n    stroke: currentColor;\n  }\n\n  width: ", ";\n  height: ", ";\n\n  svg {\n    width: ", ";\n    height: ", ";\n  }\n"])), function (props) {
  return typeof props.width === 'string' ? props.width : pxToRem(props.width || 20);
}, function (props) {
  return typeof props.height === 'string' ? props.height : pxToRem(props.height || 20);
}, function (props) {
  return typeof props.width === 'string' ? props.width : pxToRem(props.width || 20);
}, function (props) {
  return typeof props.height === 'string' ? props.height : pxToRem(props.height || 20);
});
export { StyledIcon };